const CALL_MINUTES_FEATURE_PREFIX = 'minutos-ligacoes-'
const NO_CALLS_FEATURE_NAME = 'nao-realiza-ligacoes'
const IA4COM_FEATURE_NAME = 'ia4com'

function isCallFeature (feature) {
  if (!feature || typeof feature.name !== 'string') return false
  return feature.name === NO_CALLS_FEATURE_NAME || feature.name.indexOf(CALL_MINUTES_FEATURE_PREFIX) === 0
}

function callsBenefitLabel (plan) {
  if (plan.minutes === null || plan.minutes === undefined) return 'Ligações ilimitadas'
  if (plan.minutes === 0) return 'Não realiza ligações'
  return `Até ${plan.minutes} min de ligações por mês`
}

// Benefícios de um plano em frases curtas (ligações, IA4COM e demais features do
// billing), para mostrar o que vem com uma licença fora da tela de contratação.
export function planBenefitLabels (plan) {
  const labels = [callsBenefitLabel(plan)]
  if (plan.hasIa4com === true) labels.push('IA4COM incluso')
  const features = plan.features || []
  features.forEach(feature => {
    if (isCallFeature(feature) || feature.name === IA4COM_FEATURE_NAME) return
    const title = feature.title || feature.name
    if (title && labels.indexOf(title) === -1) labels.push(title)
  })
  return labels
}



// WEBPACK FOOTER //
// ./src/components/Subscription/pricing-comparison.js